import React, { FC } from 'react';
import { Input as NativeInput } from '@tarojs/components';
import classNames from 'classnames';
import { InputProps } from '@tarojs/components/types/Input';

const Input: FC<InputProps> = ({ className, placeholderClass, disabled, ...restProps }) => (
  <NativeInput
    {...restProps}
    disabled={disabled}
    className={classNames('ink-input', { 'ink-inpput--disabled': disabled }, className)}
    placeholderClass={classNames('ink-input__placeholder', { 'ink-input__placeholder--disabled': disabled }, placeholderClass)}
  />
);

export default Input;
